const fontFamily = {
  primary: `"Rubik", sans-serif`,
  secondary: `"Inter", sans-serif`,
  tertiary: `"Source Sans Pro", sans-serif`
};

const colors = {
  background: "#eaecf5",

  // primary: "#151633",
  primaryHover: "#191b4b",
  primaryContrast: "#fff",
  primaryActive: "red", // to be defined
  primaryInactive: "red", // to be defined

  // secondary: "#202150",
  secondaryHover: "#33368a",
  secondaryContrast: "#fff",
  secondaryActive: "#292b72",
  secondaryInactive: "#b3b9cd", // to be defined

  // tertiary: "#F2F2F4",
  tertiaryHover: "#e3e5f0",
  tertiaryContrast: "#151633",
  tertiaryActive: "red", // to be defined
  tertiaryInactive: "#7787c3",

  quaternary: "transparent",
  quaternaryAlternative: "#1e22ff",
  quaternaryHover: "#02b9ffb0",
  quaternaryContrast: "#ffffff",
  quaternaryActive: "red", // to be defined
  quaternaryInactive: "red", // to be defined

  // success: "#11b36b",
  successHover: "#25dd8b",
  successContrast: "#ffffff",
  successActive: "#25dd8b",
  successInactive: "red", // to be defined

  // warning: "orange",
  warningHover: "red", // to be defined
  warningContrast: "#151633",
  warningActive: "red", // to be defined
  warningInactive: "red", // to be defined

  // error: "#d40715", // to be defined
  errorHover: "#fc6c76", // to be defined
  errorContrast: "#ffffff",
  errorActive: "purple", // to be defined
  errorInactive: "purple", // to be defined

  // Campaign Statuses
  DRAFT: "#C3FFE4",
  IN_PROGRESS: "#FFC82C",
  WAITING_FOR_APPROVAL: "#1E22FF",
  SCHEDULED: "#667EFE",
  ACTIVE: "#27DD8B",
  PAUSED: "#DCEAFF",
  FINISHED: "#1E1F46",
  REJECTED: "#FF5B3C",
  CANCELLED: "#FFBCAF"
};

export default {
  fontFamily,
  colors
};
